// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#logo[data-v-8cb2b86c] {\n  max-width: 45px;\n}\n#toolbar[data-v-8cb2b86c] {\n  z-index: 10;\n}\n.sigec-drawer[data-v-8cb2b86c] {\n  top: 56px !important;\n  height: calc(100% - 56px) !important;\n  width: 275px !important;\n}\n.sigec-list-item[data-v-8cb2b86c] {\n  -webkit-box-flex: 0;\n      -ms-flex: 0;\n          flex: 0;\n  text-transform: uppercase;\n}\n.nome-menu-lateral[data-v-8cb2b86c] {\n  text-overflow: initial;\n  white-space: initial;\n}\n", ""]);
// Exports
module.exports = exports;
